/*
 * Custom code for the homepage.
 */
$(document).ready(function () {
  // Homepage.
  var aboutContent = $(
    "#section-template--16769820492005__175ede0e-7413-4ccd-acb7-b0d99e5fdb1e"
  );

  var giftCardImage = aboutContent.find(".about-image-wrap .image-1");

  if (aboutContent.length) {
    giftCardImage.append(
      '<div class="image-wrapper"><a href="/products/fini-by-a-star-gift-card"><img src="//cdn.shopify.com/s/files/1/0661/0960/4069/files/FiniGiftCard_transformed_450x290_93d8d4f8-18c2-42d4-8983-5f26be48fae2.jpg?v=1688210379"/></a></div>'
    );
  }

  // Main menu.
  $('.header-section .main-menu li').eq(1).find('a').attr('href', '/collections');
  $('.mobile-menu .mean-nav ul li').eq(1).find('a').attr('href', '/collections');

  // Icons (menu).
  $('.header-section .header-action .user-menu-active, .header-section .header-action .header-search, .header-section .header-action .header-cart-toggle').hover(function() {
    $(this).toggleClass('active');
  });

  // Shop.
  var comingSoonTitle = $('.list-product-collection .container:first-child');
  var comingSoonContent = $('.list-product-collection .container:nth-child(2)');
  var finiTitle = $('.list-product-collection .container:nth-child(3)');
  var finiContent = $('.list-product-collection .container:nth-child(4)');
  var giftCardTitle = $('.list-product-collection .container:nth-child(5)');
  var giftCardContent = $('.list-product-collection .container:nth-child(6)');
  
  comingSoonTitle.css('display', 'block').addClass('collection-coming-soon__title');
  comingSoonContent.css('display', 'block').addClass('collection-coming-soon__content');
  finiTitle.css('display', 'none').addClass('collection-fini__title');
  finiContent.css('display', 'block').addClass('collection-fini__content');
  giftCardTitle.css('display', 'block').addClass('collection-giftcard__title');
  giftCardContent.addClass('collection-giftcard__content');
  comingSoonTitle.appendTo('.list-product-collection');
  comingSoonContent.appendTo('.list-product-collection');

  // About.
  var aboutButton = $('#section-template--16769820623077__ad2d9af7-8047-4114-8ac0-236d80898ef0 .about-content .btn');
  var textToInsert = $('<p>After a short stint at a local barbers, and having built a reputation and large customer base, Ahmed Alsanawi aka A Star Barber opened his first barbershop in 2013 aged 20. In a short space of time, the barbershop has grown into a successful business and is home to professional footballers and walk-in customers alike.</p><p></p><p>Over the years A Star\'s has travelled across the world cutting footballers and celebrities hair whilst also making sure he spends time in his barbershop seeing his regular customers who have been with him on the journey since the start. With his finger on the pulse in everything mens haircare related, A Star became increasingly frustrated at the products available to him on the market.</p><p></p><p>In the Summer of 2020, whilst cutting a World Cup Winners hair, he noticed how once he had finished cutting his hair, the footballer then applied aftershave before heading out the door.</p><p></p><p>In that moment the idea \"Fini\" was born to combine the best fragrance with the best product. Over the following 2 years A Star began working on developing his own hair styling products whilst also focussing on having a distinctive OUD fragrance.</p><p></p><p>Reflecting A-Star\'s barbershop in being \"clean, honest and cool\" Fini combines both the best ingredients for hair styling and finishing whilst also containing a perfumed OUD fragrance developed by A Star himself, paying homage to his Arabic routes.</p><p></p><p>Fini is the French meaning for the English adjective finished:</p><p></p><p>1. (of a task or activity) brought to an end; completed.</p><p>\"a preparatory drawing for the finished painting\"</p><p></p><p>2. (of a persons work) expert or accomplished.</p><p>\"his highly finished craftsmanship\"</p></p>');
  
  aboutButton.on('click', function(e) {
    e.preventDefault();
    var previousParagraph = $(this).prev();
    aboutButton.text() === "Read more"
      ? (textToInsert.insertAfter(previousParagraph), aboutButton.text("Read less"))
      : (textToInsert.remove(), aboutButton.text("Read more"));
  });
  
});
